import React, { Component } from 'react';
import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';

import MenuComponent2 from './MenuComponent2';

class Logs extends Component {
  constructor () {
    super();

    this.state = {
      items: []
    };
  }

  componentDidMount () {
      MasterDataService.retrieveLogs().then(data => {
        console.log(data);
        if (data.message === undefined){ 
            this.setState({items: data});
        }
      });
  }  

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }
    const listItems = this.state.items.map((d) => <li><b>{ d.createdAt } - { d.msg}:</b> { d.details }</li>);
    return (
      <div>
        <MenuComponent2 />  
        <ul>
          { listItems }
        </ul>
      </div>
    )
  }
}

export default Logs;